import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  appBarTitle: {
    marginLeft: theme.spacing(2),
    color: '#FFF',
    flex: 1,
  },
  notice: {
    padding: theme.spacing(1, 3),
    backgroundColor: '#FFF4E5',
    color: '#663C00',
    fontSize: 13,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
  },
  body: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  sidebar: {
    width: 320,
    flexShrink: 0,
    overflowY: 'auto',
    backgroundColor: '#F6F9FC',
    borderRight: '1px solid #E0E0E0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxHeight: '35vh',
      borderRight: 0,
      borderBottom: '1px solid #E0E0E0',
    },
  },
  moduleItem: {
    backgroundColor: '#F4F4F4',
    borderBottom: '1px solid #E0E0E0',
  },
  lessonItem: {
    paddingLeft: theme.spacing(4),
  },
  icon: {
    marginRight: theme.spacing(1),
    color: '#176AE6',
  },
  lessonIcon: {
    marginRight: theme.spacing(1),
    color: '#2DCE98',
    fontSize: 18,
  },
  label: {
    flex: 1,
    fontSize: 14,
  },
  main: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2, 5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  lessonTitle: {
    color: '#4D4F5C',
    marginBottom: theme.spacing(2),
  },
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },
}));
